import { render, staticRenderFns } from "./PurcharseInspectionReject.vue?vue&type=template&id=6bfd4a78&scoped=true&"
import script from "./PurcharseInspectionReject.vue?vue&type=script&lang=js&"
export * from "./PurcharseInspectionReject.vue?vue&type=script&lang=js&"
import style0 from "./PurcharseInspectionReject.vue?vue&type=style&index=0&id=6bfd4a78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfd4a78",
  null
  
)

export default component.exports